import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import StarRatings from 'react-star-ratings';
import { Skeleton } from '../index';
import { getExperienceName } from "../../utils";

import {
  CardTag,
  CardImageContainer,
  CardType,
  CardInfo,
  CardHeading,
  CardWay,
  CardLocation,
  CardFooter,
  CardRatingWrapper,
  CardVotes,
  CardPrice,
  CardDiscount,
  CardWithDiscountPrice,
  CrossedPrice,
} from './styles';

const HotelCard = ({
  productType,
  hotelName,
  productName,
  neighborhood,
  hotelCity,
  rating,
  reviews,
  reviewsTotal,
  price,
  oldPrice,
  image,
}) => {
  const [hasLoaded, handleLoadChange] = useState(false);
  const priceFormatted = price.toFixed(2);
  const oldPriceFormatted = oldPrice && oldPrice.toFixed(2);

  const renderPriceTag = () => {
    let content = null;
    if (price < oldPrice) {
      content = (
        <Fragment>
          <CrossedPrice>${oldPriceFormatted}</CrossedPrice>
          <CardWithDiscountPrice>
            <span>${priceFormatted}</span>/guest
          </CardWithDiscountPrice>
        </Fragment>
      );
    } else {
      content = (
        <CardPrice>
          <span>${priceFormatted}</span>/guest
        </CardPrice>
      );
    }

    if (!oldPrice) {
      content = (
        <CardPrice>
          <span>${priceFormatted}</span>/guest
        </CardPrice>
      )
    }

    return content;
  };

  return (
    <CardTag>
      <CardImageContainer>
        <CardRatingWrapper>
          <StarRatings rating={!rating || rating === 0 ? 5 : rating} numberOfStars={5} starRatedColor="#ffffff" starEmptyColor="#c2c2c2" starDimension="15px" starSpacing="0px" />
          <CardVotes>{reviews || reviewsTotal || ''}</CardVotes>
        </CardRatingWrapper>
        <CardType type={getExperienceName(productType)}>{getExperienceName(productType)}</CardType>
        {!hasLoaded && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
            <Skeleton height={180} />
          </div>
        )}
        <LazyLoad height='100%' offsetVertical={300} offsetHorizontal={1000} onContentVisible={() => handleLoadChange(true)}>
          <img src={`${process.env.CDN_URL}${image}`} alt={hotelName} />
        </LazyLoad>
        {oldPrice && price < oldPrice && (
          <CardDiscount>{Math.round(100 - (priceFormatted / oldPriceFormatted) * 100)}% off</CardDiscount>
        )}
      </CardImageContainer>
      <CardInfo>
        <CardWay>{productName}</CardWay>
        <CardHeading>{hotelName}</CardHeading>
        <CardLocation>{neighborhood || hotelCity}</CardLocation>
        <CardFooter>
          {renderPriceTag()}
        </CardFooter>
      </CardInfo>
    </CardTag>
  );
};

HotelCard.propTypes = {
  productType: PropTypes.number,
  hotelName: PropTypes.string,
  productName: PropTypes.string,
  neighborhood: PropTypes.string,
  hotelCity: PropTypes.string,
  rating: PropTypes.number,
  reviews: PropTypes.number,
  reviewsTotal: PropTypes.number,
  price: PropTypes.number,
  oldPrice: PropTypes.number,
  image: PropTypes.string,
};

export default HotelCard;
